import React from 'react';
import { List, Checkbox } from 'semantic-ui-react';
import AdditionalInformation from './AdditionalInformation';

function ItemCheckbox(props) {
	/*
        Props
            - itemId
            - checked
            - content
            - handleChange
    */

	let { itemId, checked, content, handleChange, type } = props;

	return (
		<List.Content>
			<div>
                {type === 'category' 
                    ? (
                        <div>
                            <label className="item-category">{content}</label>
                        </div>
                    )
                    : (
                        <div>
                            <Checkbox id={itemId} defaultChecked={checked} label={content} onChange={() => handleChange(itemId, checked)} />
                            <AdditionalInformation url={props.infoUrl} />
                        </div>
                    )
                }
			</div>
		</List.Content>
	);
}

export default ItemCheckbox;



// WEBPACK FOOTER //
// ./src/components/ItemCheckbox.js